module.exports = __webpack_public_path__ + "img/d5.17f4ac33.png";